// extracted by mini-css-extract-plugin
module.exports = {"Customers":"Customers_Customers__2MYEH","nav":"Customers_nav__3SjeD","left":"Customers_left__2SAy3"};